import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AccountAdminRole } from '@configs/role.config';
import { videoAssetGroups } from '@configs/videoTitles';
import { UserService } from '@services/user.service';
import { WebErrorService } from '@services/webError.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})

export class SubscriptionComponent implements OnInit {
  clientForm: FormGroup;
  perOfTestCredits: number = 0;
  negativeTestCreditsAvailable: number = 0;
  accountAdmin = AccountAdminRole.accountAdmin;
  selectedTabIndex = 0;
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(private userService: UserService, private fb: FormBuilder,private webErrorService: WebErrorService,) { }

  ngOnInit(): void {
    this.getCreditSummaryData();
    this.clientForm = this.fb.group({
      totalTestCredits: new FormControl({ value: '', disabled: true },),
      creditsConsumed: new FormControl({ value: '', disabled: true },),
      creditsAvailable: new FormControl({ value: '', disabled: true })
    });
  }

  onTraningIcon(assetGroup) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.userService.videoTutorial(assetGroup).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  getCreditSummaryData() {
    this.userService.getcreditsummary().subscribe(res => {
      if (res) {
        this.clientForm.controls.totalTestCredits.setValue(res.totalTestCredits);
        this.clientForm.controls.creditsAvailable.setValue(res.creditsAvailable);
        this.clientForm.controls.creditsConsumed.setValue(res.creditsConsumed);
        this.negativeTestCreditsAvailable = res.negativeTestCreditsAvailable;

        this.perOfTestCredits =  (res.totalTestCredits / 100) * 20;
      }
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
  }

}
